import type { State } from '../State';
import { PredefinedRewardId } from '../match2/rewards/match2-rewards.ruleset';
import { assertNever } from '../utils';
import { duration } from '../utils/duration';

/**
 * Should we claim native install reward
 */
export function hasAppInstallReward(state: State): boolean {
  return state.native.appInstallRewardStatus === 'received';
}

/**
 * Should we claim incentivised update reward
 */
export function hasIncentivisedUpdateReward(state: State): boolean {
  return state.native.appUpdateRewardStatus === 'received';
}

/**
 * Has user seen the incentivised update popup
 */
export function hasSeenIncentivisedUpdatePromo(state: State): boolean {
  return state.native.appUpdateRewardStatus === 'saw_promo';
}

/**
 * Has user already claimed the incentivised update reward
 */
export function hasClaimedIncentivisedUpdateReward(state: State): boolean {
  return state.native.appUpdateRewardStatus === 'claimed';
}

/**
 * Get id of the native rewards to grant.
 * @param state
 * @returns
 */
export function getRewardsId(_: State): PredefinedRewardId {
  return 'nativeInstallRewards';
}

/**
 * The word GUESS is used here for a purpose: we can't be 100% sure that a user has the native app,
 * but we're trying to "predict" it:
 * - check if replicant has data about native app installed,
 * - check if the native app was launched recently
 */
export function guessIsNativeAppInstalled(
  state: State,
  platform: 'IOS' | 'ANDROID',
  now: number,
  daysCooldown = 7,
): boolean {
  const { native } = state;
  let appLastLaunched: number;
  switch (platform) {
    case 'IOS':
      appLastLaunched = native.appleLastLaunched;
      break;
    case 'ANDROID':
      appLastLaunched = native.googleLastLaunched;
      break;
    default:
      assertNever(platform);
  }

  return now - appLastLaunched < duration({ days: daysCooldown });
}
